module.exports = "/assets/1de2cc8426e849ae14ff17e4133ee03c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LG.png
// module id = 2702
// module chunks = 0